import styled from '@emotion/styled';
import { Typography } from '@commandbar/design-system/components/antd';

export const Caption = styled(Typography)`
  font-size: 11px;
  line-height: 15px;
  color: #706e78;
  margin: 8px 0;
`;
